import { useContext, useState, useEffect } from "react";
import { loginContext } from "../context/contexts";

import Box from "@mui/material/Box";
import { Card } from "@mui/material";
import { Button } from "@mui/material";
import LoadingButton from "@mui/lab/LoadingButton";
import Telemetry from "./Telemetry";
import Tooltip from "@mui/material/Tooltip";

import Tab from "@mui/material/Tab";
import TabContext from "@mui/lab/TabContext";
import TabList from "@mui/lab/TabList";
import TabPanel from "@mui/lab/TabPanel";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import TableRow from "@mui/material/TableRow";
import { getobj, postobj, updateobj, updateObj } from "../apicall/apicall";
import { boxStyle, Root, buttonPosition, headerStyle } from "../style/style";
import {
  NotificationContainer,
  NotificationManager,
} from "react-notifications";

import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogTitle from "@mui/material/DialogTitle";
import { TextField } from "@mui/material";
import { useLocation } from "react-router-dom";
import ArrowBack from "@mui/icons-material/ArrowBack";
import { getKeyByValue } from "../context/contextmanager";
import { customerContext } from "../context/contexts";
import Switch from "@mui/material/Switch";
import MeasuredData from "./MeasuredData";
import { timeStamp } from "../apicall/commonFunction";
import RefreshIcon from "@mui/icons-material/Refresh";
import DeviceHistoryTrail from "./DeviceHistoryTrail";
import { month } from "../apicall/commonFunction";

export default function DeviceDetail(props) {
  const [deviceDetail, setDeviceDetail] = useState();
  const [billingChangeRequest] = useState(false);
  const [value, setvalue] = useState("1");
  const context = useContext(loginContext);
  const [open, setopen] = useState(false);
  const [comment, setcomment] = useState();
  const [refresh, setrefresh] = useState(false);
  const [checked, setchecked] = useState();
  const [loaded, setloaded] = useState(true);
  const [header, setheader] = useState();
  const [retransmit, setReTransmit] = useState(false);
  const [replaceDevice, setreplaceDevice] = useState(false);

  const customer_id = context.customer_id;

  const path = useLocation();
  const context2 = useContext(customerContext);

  const tabChange = (value) => {
    setvalue(value);
  };

  const handleCheck = (e) => {
    // console.log("here");
    setchecked(e.target.checked);
    setcomment({ id: context.id, active_status: e.target.checked });
    handleClick({ id: context.id, active_status: e.target.checked });
  };

  const handleClick = async (data) => {
    const url = process.env.REACT_APP_ZEWA_URL + "device/add-device/";
    const res = await updateObj(url, data);
    if (res.status === 200) {
      NotificationManager.remove(NotificationManager.listNotify[0]);

      NotificationManager.success(res.data.Message);
    } else {
      NotificationManager.remove(NotificationManager.listNotify[0]);

      NotificationManager.error(res.data.Message);
    }
    setopen(false);
    setrefresh(!refresh);
    // console.log(data);
  };

  const handleReTransmitData = (data) => {
    setReTransmit(true);
    const url = process.env.REACT_APP_ZEWA_URL + "device/re-transmit-data/";
    const res = postobj(url, data);
    res.then(function (data) {
      setReTransmit(false);
    });
  };

  const handleReplaceDevice = (data) => {
    setreplaceDevice(true);
    const url = process.env.REACT_APP_ZEWA_URL + "replace-device/replace-req/";
    const res = postobj(url, data);
    res.then(function (data) {
      NotificationManager.remove(NotificationManager.listNotify[0]);
      console.log(data.status);
      if (data.status === 200) {
        NotificationManager.remove(NotificationManager.listNotify[0]);

        NotificationManager.success(
          "Your Device Replacement request has been successfully received."
        );
      } else if (data.status === 401) {
        NotificationManager.remove(NotificationManager.listNotify[0]);

        NotificationManager.error(
          "Access Denied: You do not have permission to report a device replacement request. Please contact your administrator"
        );
      } else if (data.status === 400) {
        NotificationManager.remove(NotificationManager.listNotify[0]);

        NotificationManager.error(
          "You have already submitted a device replacement request. Please check your request status or contact your administrator for further assistance."
        );
      }
      setreplaceDevice(false);
    });
  };

  const handleChange = (e) => {
    setcomment({ id: context.id, comments: e.target.value });
  };

  // const Item = styled(Paper)(({ theme }) => ({
  //   backgroundColor: theme.palette.mode === "dark" ? "#1A2027" : "#fff",

  //   padding: theme.spacing(1),
  //   textAlign: "center",
  //   color: theme.palette.text.secondary,
  // }));

  const handleBack = () => {
    if (path.pathname === "/admin") {
      const nm = getKeyByValue(context.page, true);
      if (sessionStorage.getItem("page") === "DeviceList") {
        context.setpage({
          ...context.page,
          [nm]: false,
          Devices: true,
        });
      } else if (sessionStorage.getItem("page") === "hub") {
        context.setpage({
          ...context.page,
          [nm]: false,
          HubDevices: true,
        });
      } else if (sessionStorage.getItem("page") === "hubDevice") {
        context.setid(customer_id);
        context.setpage({
          ...context.page,
          [nm]: false,
          userDetail: true,
        });
      } else {
        context.setid(customer_id);

        context.setpage({
          ...context.page,
          [nm]: false,
          userDetail: true,
        });
      }
    }
    if (path.pathname === "/customer") {
      const nm = getKeyByValue(context2.manage, true);
      if (sessionStorage.getItem("page") === "hubDevice") {
        context2.setmanage({
          ...context2.manage,
          [nm]: false,
          Hubs: true,
        });
      } else {
        context2.setmanage({
          ...context2.manage,
          [nm]: false,
          Devices: true,
        });
      }
    }
    if (path.pathname === "/user") {
      const nm = getKeyByValue(context2.manage, true);
      if (sessionStorage.getItem("page") === "hubDevice") {
        context2.setmanage({
          ...context2.manage,
          [nm]: false,
          Hubs: true,
        });
      } else {
        context2.setmanage({
          ...context2.manage,
          [nm]: false,
          Devices: true,
        });
      }
    }
  };

  useEffect(() => {
    const url =
      process.env.REACT_APP_ZEWA_URL +
      "device/device-detail/" +
      context.id +
      "/";
    const d = getobj(url);
    d.then(function (res) {
      setDeviceDetail(res);
      if (res[0].imei_number === "NA") {
        setheader(res[0].group + "/" + res[0].model + "/" + res[0].mac_address);
      } else {
        setheader(res[0].group + "/" + res[0].model + "/" + res[0].imei_number);
      }
      //console.log(res[0].id,"res")
      setchecked(res[0].active_status);
      setloaded(false);
      //  console.log(res);
    }).catch((err) => {
      console.log(err);
    });
  }, [context.id, refresh]);

  const distributorBack = () => {
    props.devicedetail.setdevicedetail(false);
  };

  const [loadingIds, setLoadingIds] = useState(new Set());

  const handleBillingChangeRequest = async (data) => {
    setLoadingIds((set) => new Set(set).add(data.id));
    try {
      const url = process.env.REACT_APP_ZEWA_URL + "device/add-device/";

      updateobj(url, data).then((r) => {
        if (r.status === 200) {
          //NotificationManager.remove(NotificationManager.listNotify[0]);

          NotificationManager.success(r.Message, "Success", 2000);
          setrefresh(!refresh);
        } else {
          NotificationManager.remove(NotificationManager.listNotify[0]);

          NotificationManager.error(r.Message, "Failed", 2000);
        }
      });
    } catch (err) {
      NotificationManager.error("Network error");
    } finally {
      setLoadingIds((set) => {
        const next = new Set(set);
        next.delete(data.id);
        return next;
      });
    }
  };

  const base = (
    <Box>
      {path.pathname !== "/distributor" &&
        path.pathname !== "/distributor-user" && (
          <Card sx={boxStyle}>
            {" "}
            <Card sx={headerStyle}>{header && header}</Card>{" "}
          </Card>
        )}

      <Button
        sx={boxStyle}
        startIcon={<ArrowBack />}
        onClick={
          path.pathname === "/distributor" ||
          path.pathname === "/distributor-user"
            ? distributorBack
            : handleBack
        }
      ></Button>
      <Card
        sx={
          path.pathname !== "/distributor" &&
          path.pathname !== "/distributor-user"
            ? boxStyle
            : {}
        }
      >
        <TabContext value={value}>
          <Box
            sx={{
              borderBottom: 1,
              borderColor: "divider",
              display: "flex",
              justifyContent: "space-between",
            }}
          >
            <TabList value={value}>
              <Tab
                label="Device Detail"
                value={"1"}
                onClick={() => tabChange("1")}
              />

              <Tab
                label="Telemetry"
                value={"2"}
                onClick={() => tabChange("2")}
              />
              <Tab
                label="Raw Data"
                value={"3"}
                onClick={() => tabChange("3")}
              />
              <Tab
                label="Activity"
                value={"4"}
                onClick={() => tabChange("4")}
              />
            </TabList>
            <Button
              startIcon={<RefreshIcon />}
              sx={buttonPosition}
              onClick={() => {
                setloaded(false);
                setrefresh(!refresh);
              }}
            ></Button>
          </Box>
          <TabPanel value="1">
            {loaded ? (
              <img
                src="https://zewa-logo-bucket.s3.amazonaws.com/logo/Spinner-1s-200px.gif"
                alt="loading..."
              />
            ) : (
              <Box>
                {deviceDetail &&
                  deviceDetail.map((i) => {
                    //console.log(i)
                    return (
                      <TableContainer>
                        <Table
                          sx={{ minWidth: 650 }}
                          size="small"
                          aria-label="a dense table"
                        >
                          <TableBody>
                            <TableRow>
                              <TableCell>Device Group :</TableCell>{" "}
                              <TableCell>{i.group}</TableCell>
                              <TableCell></TableCell>
                            </TableRow>
                            <TableRow>
                              <TableCell> Model :</TableCell>
                              <TableCell>{i.model}</TableCell>
                              <TableCell></TableCell>
                            </TableRow>
                            <TableRow>
                              <TableCell>Connection Type :</TableCell>{" "}
                              <TableCell>{i.device_type}</TableCell>
                              <TableCell></TableCell>
                            </TableRow>
                            <TableRow>
                              <TableCell>Device Id-MAC:</TableCell>{" "}
                              <TableCell>{i.mac_address}</TableCell>
                              <TableCell></TableCell>
                            </TableRow>
                            <TableRow>
                              <TableCell>IMEI Number:</TableCell>{" "}
                              <TableCell>{i.imei_number}</TableCell>
                              <TableCell></TableCell>
                            </TableRow>
                            <TableRow>
                              <TableCell>SIM:</TableCell>{" "}
                              <TableCell>{i.iccid}</TableCell>
                              <TableCell></TableCell>
                            </TableRow>
                            <TableRow>
                              <TableCell>SIM Status:</TableCell>{" "}
                              <TableCell>{i.sim_status}</TableCell>
                              <TableCell></TableCell>
                            </TableRow>
                            <TableRow>
                              <TableCell>Data Used:</TableCell>{" "}
                              <TableCell>
                                {i.data_usage / 1000 + "Kb"}
                              </TableCell>
                              <TableCell></TableCell>
                            </TableRow>

                            <TableRow>
                              <TableCell> Serial Number:</TableCell>{" "}
                              <TableCell>{i.serial_number}</TableCell>
                              <TableCell></TableCell>
                            </TableRow>
                            <TableRow>
                              <TableCell> Hub Id:</TableCell>{" "}
                              <TableCell>
                                {i.hub_id === null ? "NA" : i.hub_id.hub_id}
                              </TableCell>
                              <TableCell></TableCell>
                            </TableRow>
                            {i.hub_id !== null && (
                              <TableRow>
                                <TableCell> Hub Free Period:</TableCell>{" "}
                                <TableCell>
                                  {i?.hub_id?.free_period_detail
                                    ?.free_time_period
                                    ? `${i.hub_id.free_period_detail.free_time_period} Months`
                                    : "0 Months"}
                                </TableCell>
                                <TableCell></TableCell>
                              </TableRow>
                            )}
                            <TableRow>
                              <TableCell> Provisioned At:</TableCell>{" "}
                              <TableCell>
                                {month[
                                  i.created_at.split("T")[0].split("-")[1]
                                ] +
                                  " " +
                                  i.created_at.split("T")[0].split("-")[2] +
                                  " " +
                                  i.created_at.split("T")[0].split("-")[0]}
                              </TableCell>
                              <TableCell></TableCell>
                            </TableRow>
                            <TableRow>
                              <TableCell> Last Active:</TableCell>{" "}
                              <TableCell>
                                {i.imei_number === "NA"
                                  ? timeStamp(parseInt(i.utc))
                                  : timeStamp(parseInt(i.utc, 16))}
                              </TableCell>
                              <TableCell></TableCell>
                            </TableRow>
                            <TableRow>
                              <TableCell> Battery:</TableCell>{" "}
                              <TableCell>
                                {/* {timeStamp(i.utc)} */}
                                {i.battery + " %"}
                              </TableCell>
                              <TableCell></TableCell>
                            </TableRow>
                            <TableRow>
                              <TableCell> Activation Date:</TableCell>{" "}
                              <TableCell>
                                {i.activation_date
                                  ? month[
                                      i.activation_date
                                        .split("T")[0]
                                        .split("-")[1]
                                    ] +
                                    " " +
                                    i.activation_date
                                      .split("T")[0]
                                      .split("-")[2] +
                                    " " +
                                    i.activation_date
                                      .split("T")[0]
                                      .split("-")[0]
                                  : "Not activated yet"}
                              </TableCell>
                              <TableCell></TableCell>
                            </TableRow>

                            <TableRow>
                              <TableCell> Status:</TableCell>{" "}
                              <TableCell>
                                {i.active_status === false
                                  ? "Inactive"
                                  : "Active"}
                              </TableCell>
                              <Tooltip
                                placement="bottom-start"
                                title={
                                  i.billing_type === "Yearly" &&
                                  i.activation_status
                                    ? "Status of the yearly billing devices cannot be changed"
                                    : "Update the device status"
                                }
                              >
                                <TableCell>
                                  <Switch
                                    checked={checked}
                                    disabled={
                                      i.billing_type === "Yearly" &&
                                      i.activation_status
                                    }
                                    onChange={handleCheck}
                                    name="status"
                                    inputProps={{ "aria-label": "controlled" }}
                                  />
                                </TableCell>
                              </Tooltip>
                            </TableRow>
                            {i.hub_id === null && (
                              <TableRow>
                                <TableCell>Free Period:</TableCell>{" "}
                                <TableCell>
                                  {i.free_period.free_time_period + " Months"}
                                </TableCell>
                                <TableCell></TableCell>
                              </TableRow>
                            )}
                            <TableRow>
                              <TableCell> Billing Type:</TableCell>{" "}
                              <TableCell>{i.billing_type}</TableCell>
                              <Tooltip
                                placement="bottom-start"
                                title={
                                  i.billing_type_change_requested
                                    ? "Device billing type change is already requested."
                                    : "Request to change the billing type."
                                }
                              >
                                <TableCell>
                                  <Button
                                    disabled={i.billing_type_change_requested}
                                    onClick={() =>
                                      handleBillingChangeRequest({
                                        id: i.id,
                                        billing_type_change_requested:
                                          !billingChangeRequest,
                                      })
                                    }
                                  >
                                    {loadingIds.has(i.id)
                                      ? "Requesting…"
                                      : "Request to change"}
                                  </Button>
                                </TableCell>
                              </Tooltip>
                            </TableRow>
                            <TableRow>
                              <TableCell>Comment:</TableCell>{" "}
                              <TableCell>{i.comments}</TableCell>
                              <TableCell>
                                <Button
                                  onClick={() => {
                                    setopen(!open);
                                  }}
                                >
                                  Update
                                </Button>
                              </TableCell>
                            </TableRow>

                            {path.pathname === "/admin" && (
                              <TableRow>
                                <TableCell>Re-transmit data:</TableCell>{" "}
                                <TableCell>{i.comments}</TableCell>
                                <TableCell>
                                  <LoadingButton
                                    size="small"
                                    onClick={() =>
                                      handleReTransmitData({
                                        id: i.id,
                                        customer_id: customer_id,
                                      })
                                    }
                                    endIcon={<RefreshIcon />}
                                    loading={retransmit}
                                    loadingPosition="end"
                                    variant="contained"
                                  >
                                    <span>Send</span>
                                  </LoadingButton>
                                </TableCell>
                              </TableRow>
                            )}
                            {i.imei_number !== "NA" && (
                              <TableRow>
                                <TableCell>Replace Device:</TableCell>{" "}
                                <TableCell></TableCell>
                                <TableCell>
                                  <Tooltip
                                    title={
                                      i.replace_requested
                                        ? "Device replacement is already requested."
                                        : "Request for replacement."
                                    }
                                  >
                                    <div>
                                      <LoadingButton
                                        size="small"
                                        onClick={() =>
                                          handleReplaceDevice({ dev_id: i.id })
                                        }
                                        endIcon={<RefreshIcon />}
                                        loading={replaceDevice}
                                        loadingPosition="end"
                                        variant="contained"
                                        disabled={i.replace_requested}
                                      >
                                        <span>Replace</span>
                                      </LoadingButton>
                                    </div>
                                  </Tooltip>
                                </TableCell>
                              </TableRow>
                            )}
                          </TableBody>
                        </Table>
                      </TableContainer>
                    );
                  })}
              </Box>
            )}
          </TabPanel>
          <TabPanel value="3">
            <Telemetry id={context.id} refresh={refresh} />
          </TabPanel>
          <TabPanel value="2">
            <MeasuredData id={context.id} refresh={refresh} />
          </TabPanel>
          <TabPanel value="4">
            <DeviceHistoryTrail id={context.id} refresh={refresh} />
          </TabPanel>
        </TabContext>
      </Card>
      <Dialog
        open={open}
        onClose={() => {
          setopen(false);
        }}
      >
        <DialogTitle>Update Comment</DialogTitle>
        <DialogContent>
          <TextField
            id="name"
            label="Enter Comment"
            type="text"
            variant="standard"
            onChange={handleChange}
          />
        </DialogContent>
        <DialogActions>
          <Button
            variant="contained"
            color="primary"
            onClick={() => {
              handleClick(comment);
            }}
          >
            Update
          </Button>
          <Button
            variant="contained"
            color="error"
            onClick={() => {
              setopen(false);
            }}
          >
            cancel
          </Button>
        </DialogActions>
      </Dialog>
      <NotificationContainer />
    </Box>
  );
  return (
    <div>
      {path.pathname === "/admin" ? <Root>{base}</Root> : <div>{base}</div>}
    </div>
  );
}
